import * as titleFormationStyles from '../../styles/internal-page/title-formation.module.scss';
import PropTypes from 'prop-types';

import React, {Fragment} from 'react';
import clsx from 'clsx';
import IconContainer from './IconContainer';

const TitleFormation = React.memo(function TitleFormation ({
  label, subtitle, contents,
}) {
  return (
    <div
      className={titleFormationStyles.rootTitle}
    >
      <h1 className={titleFormationStyles.title}>
        {label}
      </h1>
      <div className={titleFormationStyles.dividerContent}>
        <div className={titleFormationStyles.dividerContentItem}>
          <div
            className={titleFormationStyles.horizontalBar}
          >
          </div>
        </div>
      </div>
      {subtitle &&
        <div className={titleFormationStyles.subtitleContent}>
          <p
            className={titleFormationStyles.subtitle}
          >
            {subtitle}
          </p>
        </div>
      }
      {contents.length !== 0 &&
      <div className={titleFormationStyles.actionRoot}>
        {contents.map((content, index) => {
          return (
            <Fragment key={index}>
              {content.url &&
              <a
                className={clsx(titleFormationStyles.actionItem,
                  {[titleFormationStyles.actionItemLink]: content.url}
                )}
                href={content.url}
                rel="noreferrer"
                target={content.open_in_new_page ? '_blank' : ''}
              >
                <IconContainer
                  classname={clsx(titleFormationStyles.actionIcon,
                    {[titleFormationStyles.actionNoLink]: !content.url})}
                  color="WHITE"
                  icon={content.icon}
                  size={30}
                  variant="full"
                />
                {!content.icon && <div className={titleFormationStyles.noIcon}/>}
                <p className={titleFormationStyles.labelContent}>
                  {content.label}
                </p>
              </a>
              }
              {!content.url &&
                <div
                  className={clsx(titleFormationStyles.actionItem,
                    {[titleFormationStyles.actionItemLink]: content.url})}
                >
                  <IconContainer
                    classname={clsx(titleFormationStyles.actionIcon,
                      {[titleFormationStyles.actionNoLink]: !content.url})}
                    color="WHITE"
                    icon={content.icon}
                    size={26}
                    variant="full"
                  />
                  {!content.icon && <div className={titleFormationStyles.noIcon}/>}
                  <p className={clsx(titleFormationStyles.labelContent,
                    {[titleFormationStyles.actionNoLink]: !content.url})}
                  >
                    {content.label}
                  </p>
                </div>
              }
            </Fragment>
          );
        })}
      </div>}
    </div>);
});

TitleFormation.propTypes = {
  contents: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      open_in_new_page: PropTypes.bool,
      icon: PropTypes.string,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  label: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};

export default TitleFormation;
